import { type MCPServerInfo } from '../../types';

const GoogleDocsServer: MCPServerInfo = {
  serverId: 'GOOGLE_DOCS',
  name: 'Google Docs',
  slug: 'google-docs',
  description:
    'Google Docs MCP Server for searching, reading, creating, and editing documents',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'https://github.com/natomalabs/google-mcp-servers',
    commitSha: 'f86a7e2e',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default GoogleDocsServer;
